import React, { useContext } from 'react';
import { NavMenu } from './NavMenu';
import { NavSideMenu } from './Navigation/NavSideMenu';
import { UserContext, LoginType } from './UserAccess/UserContext';
import { Button } from 'react-bootstrap';

const LandingPage = ({ signIn }: { signIn: () => void }) =>
  <main
    id="content"
    role="main"
    className="navbar-sidebar-aside-sm"
    style={{
      backgroundImage: `url(/Login_Page_Background.jpg)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: '100vh',
      width: '100vw',
    }}>
    <header className="navbar fixed-top" style={{ zIndex: 100 }}>
      <div className="container-fluid">
        <img className="m-2" src="/KA-RGB-color_logo.png" alt="Logo" width='100' style={{ minWidth: '15rem', maxWidth: '15rem' }} />
      </div>
    </header>
    <img
      className="w-50 position-absolute start-50 translate-middle"
      style={{ top: '40%' }}
      src="/Constellation_RGB_Subheading_White.png"
      alt="Constellation" />
    <div className="position-absolute start-50 translate-middle" style={{ top: '60%' }}>
      <Button
        className="bg-ka-blue"
        size="lg"
        style={{ fontSize: '1.5rem' }}
        onClick={signIn}>
        Sign In
      </Button>
    </div>
  </main>

const DisabledAlert = () =>
  <div className="alert alert-soft-danger mt-n5 mb-5 mx-n1" role="alert">
    Communication with sites has been interrupted. Please contact Kahler Automation for more details.
  </div>

const SandboxAlert = () =>
  <div className="alert alert-soft-danger mt-n5 mb-5 mx-n1" role="alert">
    Sandbox Testing Version
  </div>

type Props = {
  children: React.ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  const { user, busy, login } = useContext(UserContext);
  const showLandingPage = user === null && window.location.pathname === '/';

  if (busy) return <></>;
  if (showLandingPage) return <LandingPage signIn={login} />;

  return <>
    <NavMenu />
    <main id="content" role="main" className="navbar-sidebar-aside-sm">
      <NavSideMenu />
      <div className="navbar-sidebar-aside-content content-space-t-1 content-space-b-2 px-lg-5">
        {user?.userType === LoginType.User && user.selectedBusiness?.disabled && <DisabledAlert />}
        {user?.userType === LoginType.User && user.selectedBusiness?.sandbox && <SandboxAlert />}
        {children}
      </div>
    </main>
  </>
}

export { Layout };
